export const Timer = {
	template: `
		<div class="calendar-sharing__timer_box">
			<div class="calendar-sharing__time_count-box">
				<div class="calendar-sharing__time_count-item">18</div>
				<div class="calendar-sharing__time_count-item">19</div>
				<div class="calendar-sharing__time_count-item">20</div>
			</div>
			<div class="calendar-sharing__timer_title">{{ $Bitrix.Loc.getMessage('CALENDAR_SHARING_TIMER_TITLE') }}</div>
			<div class="calendar-sharing__timer_desc">{{ $Bitrix.Loc.getMessage('CALENDAR_SHARING_TIMER_DESC') }}</div>
		</div>
	`,
};
